import cn from "classnames";

import * as styles from "@atoms/spinner-loader/SpinnerLoader.module.scss";

const SpinnerLoader = (): JSX.Element => {
  return <span className={cn(styles.spinnerLoader, "at-spinner-loader")}></span>;
};

export default SpinnerLoader;
